import { __assign, __makeTemplateObject, __read, __rest } from "tslib";
import React, { forwardRef, useMemo, useState } from 'react';
import clsx from 'clsx';
import MuiCard from '@material-ui/core/Card';
import { combineClasses, omit, useThemeProps, } from '../../../foundation';
import styled from '../../../foundation/styled-components';
import { RcCardContext } from './CardContext';
import { CardStyle } from './styles';
import { RcCardClasses } from './utils';
var _RcCard = forwardRef(function (inProps, ref) {
    var _a;
    var props = useThemeProps({ props: inProps, name: 'RcCard' });
    var classesProp = props.classes, classNameProp = props.className, selected = props.selected, focusVisibleProp = props.focusVisible, rest = __rest(props, ["classes", "className", "selected", "focusVisible"]);
    var _b = __read(useState(false), 2), focusVisible = _b[0], setFocusVisible = _b[1];
    var classes = useMemo(function () {
        return combineClasses(omit(RcCardClasses, ['selected', 'focusVisible']), classesProp);
    }, [classesProp]);
    var className = clsx(classNameProp, (_a = {},
        _a[RcCardClasses.focusVisible] = focusVisibleProp || focusVisible,
        _a[RcCardClasses.selected] = selected,
        _a));
    return (React.createElement(RcCardContext.Provider, { value: { focusVisible: focusVisible, setFocusVisible: setFocusVisible } },
        React.createElement(MuiCard, __assign({}, rest, { className: className, ref: ref, classes: classes }))));
});
var RcCard = styled(_RcCard)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), CardStyle);
RcCard.displayName = 'RcCard';
RcCard.defaultProps = {};
export { RcCard };
var templateObject_1;
